/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.6.12
 */
import Tool from './Tool'
import Circle from '@/marker/Circle'
// let { Circle } = L;
/**
 * 圆形绘制工具
 */
export default class CircleTool extends Tool {
  marker
  options = { feature: { color: 'red', fillOpacity: .5, weight: 1 } }
  /**
   * 启动
   */
  start() {
    this.onMouseMove = this.onMouseMove.bind(this)
    this.onMouseDown = this.onMouseDown.bind(this)
    let { map } = this;
    map.once('mousedown', this.onMouseDown);
  }
  /**
   * 取消
   */
  cancel() {
    let { map } = this;
    map.off('mousedown', this.onMouseDown);
    map.off('mousemove', this.onMouseMove);
  }
  /**
   * 
   * @param e 
   */
  onMouseDown(e) {
    let { options } = this;
    let { map, layer } = this;
    let { latlng } = e;
    this.clear();//重复绘制，先移除旧图元
    //
    this.marker = new Circle(latlng, options.feature).addTo(layer)
    map.on('mousemove', this.onMouseMove);
    map.once('mouseup', this.onEnd.bind(this));
  }
  /**
   * 
   * @param e 
   */
  onMouseMove(e) {
    let { marker } = this;
    let latlng = e.latlng;
    let center = marker.getLatLng();
    let r = latlng.distanceTo(center);
    marker.setRadius(r)
    marker.redraw();
  }
}



// WEBPACK FOOTER //
// ./src/plugins/tools/CircleTool.js